module.exports = __webpack_public_path__ + "img/humons1.9f951154.png";